// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"678":"6f9887c683b768c3c5ed","731":"4c1e76c10075794178e2","843":"4d22e4d87d98fa226c97","883":"d32cdb23aed4779f33f9"}[chunkId] + ".js";
};